import React from 'react'

import { ColorTypeBackground } from './types'

interface HorizontalLineProps {
    className?: string
    color: ColorTypeBackground
}

export const HorizontalLine: React.FC<HorizontalLineProps> = ({ className, color }) => {
    return <hr className={`${color} ${className} h-[5px] border-0`} />
}
